module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subject-table"
  }, _vm._l((_vm.filteredKlassCals), function(klassCal) {
    return _c('table', {
      key: klassCal.id,
      staticClass: "do-table"
    }, [_c('thead', [_c('tr', [(_vm.isEditingDates) ? _c('th', {
      staticClass: "subject-table__th subject-table__th--select"
    }) : _vm._e(), _vm._v(" "), _c('th', {
      staticClass: "subject-table__th subject-table__th--name"
    }, [_vm._v(_vm._s(klassCal.name))]), _vm._v(" "), _c('th', {
      staticClass: "subject-table__th subject-table__th--type"
    }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
      staticClass: "subject-table__th subject-table__th--teachers"
    }, [_vm._v("Personale")]), _vm._v(" "), (_vm.showDates) ? _c('th', {
      staticClass: "subject-table__th subject-table__th--date"
    }, [_vm._v("\n          Startdato\n          "), _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'top'
        }),
        expression: "{ arrow: true, placement: 'top' }"
      }],
      staticClass: "icon-wrench subject-table__wrench",
      attrs: {
        "content": "Rediger datoer på flere fag"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$emit('toggleEditDates')
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.showDates) ? _c('th', {
      staticClass: "subject-table__th subject-table__th--date"
    }, [_vm._v("\n          Slutdato\n          "), _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'top'
        }),
        expression: "{ arrow: true, placement: 'top' }"
      }],
      staticClass: "icon-wrench subject-table__wrench",
      attrs: {
        "content": "Rediger datoer på flere fag"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$emit('toggleEditDates')
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.showSubjectsRequest) ? _c('th', {
      staticClass: "subject-table__th subject-table__th--requested"
    }, [_vm._v("Ønsket af")]) : _vm._e(), _vm._v(" "), _c('th', {
      staticClass: "subject-table__th subject-table__th--rooms"
    }, [_vm._v("Lokaler")]), _vm._v(" "), _c('th', {
      staticClass: "subject-table__th subject-table__th--klasses"
    }, [_vm._v("Klasser")]), _vm._v(" "), _c('th', {
      staticClass: "subject-table__th subject-table__th--lessons"
    }, [_vm._v("Lek. pr. uge: " + _vm._s(_vm.totalLessons(klassCal.vSubjects)))]), _vm._v(" "), _c('th', {
      staticClass: "subject-table__th subject-table__th--hours"
    }, [_vm._v("Timer: " + _vm._s(_vm.totalHours(klassCal.vSubjects, klassCal.id)))])])]), _vm._v(" "), _c('tbody', [(klassCal.vSubjects.length === 0) ? _c('tr', [_c('td', {
      staticClass: "subject-table__empty",
      attrs: {
        "colspan": 7 + (_vm.showSubjectsRequest ? 1 : 0) + (_vm.showDates ? 2 : 0) + (_vm.isEditingDates ? 1 : 0)
      }
    }, [_vm._v("Ingen fag")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedSubjects(klassCal.vSubjects)), function(subject) {
      return _c('tr', {
        key: subject.id,
        staticClass: "subject-table__row",
        class: {
          'subject-table__row--selected': _vm.isEditingDates && _vm.selectedSubjectIds.indexOf(subject.id) >= 0
        },
        on: {
          "click": function($event) {
            return _vm.onRowClick(subject, klassCal.id)
          }
        }
      }, [(_vm.isEditingDates) ? _c('td', {
        staticClass: "subject-table__td subject-table__td--select",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.$emit('toggleSubjectSelection', subject.id)
          }
        }
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.selectedSubjectIds.indexOf(subject.id) >= 0
        }
      })]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "subject-table__td subject-table__td--name"
      }, [_c('span', {
        staticClass: "subject-table__color-dot",
        style: ({
          background: subject.color
        })
      }), _vm._v("\n          " + _vm._s(subject.name) + "\n        ")]), _vm._v(" "), _c('td', {
        staticClass: "subject-table__td subject-table__td--type"
      }, [_vm._v("\n          " + _vm._s(_vm.subjectTypeLabel(subject.subject_type)) + "\n        ")]), _vm._v(" "), _c('td', {
        staticClass: "subject-table__td subject-table__td--teachers"
      }, [(_vm.showTeacherPoolHours && subject.vTeachersWithPool && subject.vTeachersWithPool.length) ? _vm._l((subject.vTeachersWithPool), function(teacher, teacherIdx) {
        return _c('span', {
          key: teacherIdx,
          staticClass: "subject-table__teacher"
        }, [(teacherIdx > 0) ? [_vm._v(", ")] : _vm._e(), _vm._v(_vm._s(teacher.name)), (teacher.hours != null) ? _c('span', {
          staticClass: "subject-table__teacher-pool"
        }, [_vm._v(" (" + _vm._s(_vm.formatTeacherPoolHours(teacher.hours, subject)) + ")")]) : _vm._e()], 2)
      }) : [_vm._v("\n            " + _vm._s(subject.vUserNames && subject.vUserNames.length ? subject.vUserNames.join(', ') : '') + "\n          ")]], 2), _vm._v(" "), (_vm.showDates) ? _c('td', {
        staticClass: "subject-table__td subject-table__td--date"
      }, [_vm._v("\n          " + _vm._s(_vm.formatDate(subject.from_date)) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showDates) ? _c('td', {
        staticClass: "subject-table__td subject-table__td--date"
      }, [_vm._v("\n          " + _vm._s(_vm.formatDate(subject.to_date)) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showSubjectsRequest) ? _c('td', {
        staticClass: "subject-table__td subject-table__td--requested"
      }, [_vm._v("\n          " + _vm._s(subject.vRequestedBy && subject.vRequestedBy.length ? subject.vRequestedBy.join(', ') : '') + "\n        ")]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "subject-table__td subject-table__td--rooms"
      }, [_vm._v("\n          " + _vm._s(_vm.getRoomNames(subject)) + "\n        ")]), _vm._v(" "), _c('td', {
        staticClass: "subject-table__td subject-table__td--klasses"
      }, [_vm._v("\n          " + _vm._s(subject.v_subjectOtherKlasses && subject.v_subjectOtherKlasses.length ? subject.v_subjectOtherKlasses.join(', ') : '') + "\n        ")]), _vm._v(" "), _c('td', {
        staticClass: "subject-table__td subject-table__td--lessons"
      }, [(_vm.isExcludedFromLessons(subject)) ? _c('span', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            arrow: false,
            placement: 'left'
          }),
          expression: "{ arrow: false, placement: 'left' }"
        }],
        staticClass: "subject-table__excluded-icon",
        attrs: {
          "content": "Tæller ikke med i totalen"
        }
      }, [_vm._v("ⓘ")]) : _vm._e(), _vm._v("\n          " + _vm._s(subject.vLessonsPerWeek) + "\n        ")]), _vm._v(" "), _c('td', {
        staticClass: "subject-table__td subject-table__td--hours"
      }, [(_vm.isExcludedFromLessons(subject)) ? _c('span', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            arrow: false,
            placement: 'left'
          }),
          expression: "{ arrow: false, placement: 'left' }"
        }],
        staticClass: "subject-table__excluded-icon",
        attrs: {
          "content": "Tæller ikke med i totalen"
        }
      }, [_vm._v("ⓘ")]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.getHoursForKlass(subject, klassCal.id)) + "\n        ")])])
    })], 2)])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b02dd76!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/SubjectsDistributionTable.vue
// module id = 1827
// module chunks = 1